import { useState } from 'react'
import { useAppDispatch, useAppSelector } from '@/store/hooks'
import { resetDevState, setNetworkLatency } from './devSlice'
import { AuthSection } from './sections/AuthSection'
import { MockStatesSection } from './sections/MockStatesSection'

export const DevPanel = () => {
  const [open, setOpen] = useState(false)
  const dispatch = useAppDispatch()
  const state = useAppSelector((s) => s.dev)

  if (!import.meta.env.DEV) return null

  return (
    <>
      <button
        onClick={() => setOpen((o) => !o)}
        className="fixed bottom-4 right-4 z-50 bg-slate-900 text-white rounded-full px-3 py-2 text-xs font-mono shadow-lg"
      >
        DEV
      </button>
      {open ? (
        <div className="fixed bottom-20 right-4 z-50 bg-background border rounded-lg shadow-xl w-80 p-4 space-y-3 text-sm max-h-[80vh] overflow-y-auto">
          <div className="font-bold">Dev panel</div>
          <AuthSection state={state} />
          <MockStatesSection state={state} />
          <div className="space-y-2">
            <div className="text-xs font-semibold uppercase text-muted-foreground">Misc</div>
            <label className="block">
              <span className="text-xs">Network delay (ms)</span>
              <input
                type="number"
                value={state.networkLatencyMs}
                onChange={(e) => dispatch(setNetworkLatency(Number(e.target.value) || 0))}
                className="w-full rounded border px-2 py-1 text-xs"
              />
            </label>
          </div>
          <button
            onClick={() => dispatch(resetDevState())}
            className="w-full rounded border px-2 py-1 text-xs"
          >
            Reset to defaults
          </button>
        </div>
      ) : null}
    </>
  )
}
